import React, { useEffect, useState } from "react";
import { Table, Pagination } from "react-bootstrap";
import './Heatmap.css';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import MultipleSelectChip from "../Reusable components/MultiselectwithSearch";
import { useDispatch, useSelector } from "react-redux";
import { getHeatmapDropdownData, getHeatmapTableData } from "../../actions/Applications/heatmap.action";
import Download from './../../assets/images/Download.png'
import AdminBreadcrumb from "../../components/Administration/General/Admin-breadcrumb";
import { useHistory } from "react-router-dom";



const ITEMS_PER_PAGE = 10;
const PAGE_WINDOW_SIZE = 5;

const Heatmap = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const heatmapTableData = useSelector((state)=> state.heatmapReducer.heatmapTableData)
  const heatmapDropdownData = useSelector((state)=> state.heatmapReducer.heatmapDropdownData)
   const RoleId = localStorage.getItem('Role_id');

  console.log('mmmmmmmmmmmm',heatmapTableData,heatmapDropdownData)

  useEffect(() => {
      dispatch(getHeatmapDropdownData(RoleId))
    }, [dispatch,RoleId]);

  // ------------------ STATE ------------------
  const [currentPage, setCurrentPage] = useState(1);

  const [selectedRegions, setSelectedRegions] = useState([]);
  const [selectedServiceDesks, setSelectedServiceDesks] = useState([]);
  const [selectedCustomers, setSelectedCustomers] = useState([]);

  // 🔹 ID states (what you actually need)
  const [selectedRegionIds, setSelectedRegionIds] = useState([]);
  const [selectedServiceDeskIds, setSelectedServiceDeskIds] = useState([]);
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);

  const [regionSearch, setRegionSearch] = useState("");
const [serviceDeskSearch, setServiceDeskSearch] = useState("");
const [customerSearch, setCustomerSearch] = useState("");

  // ------------------ SAFE DATA ------------------
  const headers = heatmapTableData?.[0]?.Headers || [];
  const details = heatmapTableData?.[0]?.Details || [];
  const regions = heatmapDropdownData?.[0]?.Region || [];

  // ------------------ PAGINATION ------------------
  const totalPages = Math.ceil(details.length / ITEMS_PER_PAGE);

  const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
  const currentItems = details.slice(indexOfFirstItem, indexOfLastItem);

  let startPage = Math.max(
    1,
    currentPage - Math.floor(PAGE_WINDOW_SIZE / 2)
  );
  let endPage = startPage + PAGE_WINDOW_SIZE - 1;

  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - PAGE_WINDOW_SIZE + 1);
  }

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };


  // ------------------ REGION ------------------
  const regionOptions = regions
    .map(r => r["P&L Region"])
    .filter(val => typeof val === "string");

  const handleRegionChange = (val) => {
    setSelectedRegions(val);

    const ids = regions
      .filter(r => val.includes(r["P&L Region"]))
      .map(r => r.RegionID);

    setSelectedRegionIds(ids);

    setSelectedServiceDesks([]);
    setSelectedServiceDeskIds([]);
    setSelectedCustomers([]);
    setSelectedCustomerIds([]);
  };

 const filteredRegionOptions = regionOptions.filter(option =>
  option
    ?.toString()
    .toLowerCase()
    .includes((regionSearch || "").toString().toLowerCase())
);

  // ------------------ SERVICEDESK ------------------
  const filteredServiceDesks = regions
    .filter(r => selectedRegions.includes(r["P&L Region"]))
    .flatMap(r => r.Servicedesk || []);

  const serviceDeskOptions = [
    ...new Set(
      filteredServiceDesks
        .map(sd => sd.Servicedesk)
        .filter(val => typeof val === "string")
    )
  ];

  const handleServiceDeskChange = (val) => {
    setSelectedServiceDesks(val);

    const ids = filteredServiceDesks
      .filter(sd => val.includes(sd.Servicedesk))
      .map(sd => sd.ServicedeskID);

    setSelectedServiceDeskIds(ids);

    setSelectedCustomers([]);
    setSelectedCustomerIds([]);
  };

  const filteredServiceDeskOptions = serviceDeskOptions.filter(option =>
  option.toLowerCase().includes(serviceDeskSearch.toLowerCase())
);

  // ------------------ CUSTOMER ------------------
  const filteredCustomers = filteredServiceDesks
    .filter(sd => selectedServiceDesks.includes(sd.Servicedesk))
    .flatMap(sd => sd.Customer || []);

  const customerOptions = [
    ...new Set(
      filteredCustomers
        .map(c => c.CustomerName)
        .filter(val => typeof val === "string")
    )
  ];

  const handleCustomerChange = (val) => {
    setSelectedCustomers(val);

    const ids = filteredCustomers
      .filter(c => val.includes(c.CustomerName))
      .map(c => c.CustomerID);

    setSelectedCustomerIds(ids);
  };

  const filteredCustomerOptions = customerOptions.filter(option =>
  option.toLowerCase().includes(customerSearch.toLowerCase())
);

// const buildQueryString = () => {
//   const params = [];

//   // RoleID (static)
//   params.push("RoleID=1");

//   // Customer IDs
//   selectedCustomerIds.forEach(id => {
//     params.push(`CustomerID[]=${id}`);
//   });

//   // ServiceDesk IDs
//   selectedServiceDeskIds.forEach(id => {
//     params.push(`ServicedeskID[]=${id}`);
//   });

//   // Region Names (API expects region name, not ID)
//   selectedRegions.forEach(region => {
//     params.push(`Region[]=${encodeURIComponent(region)}`);
//   });

//   return params.join("&");
// };


const buildQueryString = () => {
  const params = [];

  // 1️⃣ RoleID (static)
  params.push(`RoleID= ${RoleId}`);

  // 2️⃣ Region (comma separated)
  if (selectedRegions.length > 0) {
    params.push(
      `Region=${selectedRegions.map(r => encodeURIComponent(r)).join(",")}`
    );
  }

  // 3️⃣ ServicedeskID (comma separated)
  if (selectedServiceDeskIds.length > 0) {
    params.push(
      `ServicedeskID=${selectedServiceDeskIds.join(",")}`
    );
  }

  // 4️⃣ CustomerID (comma separated)
  if (selectedCustomerIds.length > 0) {
    params.push(
      `CustomerID=${selectedCustomerIds.join(",")}`
    );
  }

  return params.join("&");
};
const handleFilter = () => {
  const query = buildQueryString();
  dispatch(getHeatmapTableData(query));
};


  console.log("Selected Names:", {
    selectedRegions,
    selectedServiceDesks,
    selectedCustomers
  });

  console.log("Selected IDs:", {
    selectedRegionIds,
    selectedServiceDeskIds,
    selectedCustomerIds
  });

  // ------------------ UI ------------------
  return (
    <div>
    <AdminBreadcrumb value1={()=>history.push('/applications')} label1='Applications' isActive2={true} value2={()=>history.push('/heatmap')} label2='HeatMap' isActive3={false} label3='HeatMap Table'/>

    <div className="container-fluid mt-4 px-3">

      <div style={{ display: "flex", gap: 20 }}>
<main>
      <div className='multiSelectLabel'>Region</div>
        <MultipleSelectChip
          options={regionOptions}
           label="Recommendations"
          value={selectedRegions}
          onChange={handleRegionChange}
          placeholder="Search Region"
          searchQuery={regionSearch}
           selectAllEnabled={true}
          onSearchQueryChange={(e)=>setRegionSearch(e.target.value)}
        />
        </main>
<main>
      <div className='multiSelectLabel'>Country</div>
        <MultipleSelectChip
        options={serviceDeskOptions}
           label="Recommendations"
          value={selectedServiceDesks}
          onChange={handleServiceDeskChange}
          placeholder="Search Country"
           searchQuery={serviceDeskSearch}
           selectAllEnabled={true}
          onSearchQueryChange={(e)=>setServiceDeskSearch(e.target.value)}
        />
</main>
<main>
      <div className='multiSelectLabel'>Account</div>
        <MultipleSelectChip
          options={customerOptions}
          value={selectedCustomers}
          onChange={handleCustomerChange}
          placeholder="Search Account"
           searchQuery={customerSearch}
           selectAllEnabled={true}
          onSearchQueryChange={(e)=>setCustomerSearch(e.target.value)}
        />
        </main>


        <div className="btn_adduser" style={{marginTop:20}} onClick={()=>handleFilter()}>SUBMIT</div>
        <span style={{marginTop:20}}><img src={Download} alt='' style={{ marginRight: '10px',height:40 }}      
           onClick={() => { window.location.href = `${process.env.REACT_APP_BASE_URL}/api/usp/HeatMapExport?${buildQueryString()}&format=excel&filename=heatmap_report.xlsx` }}
/></span>
      </div>

       
          
      

      <div className="heatmap-wrapper">
        <Table bordered hover className="heatmap-table text-center align-middle mb-0">
          <thead className="table-secondary">
            <tr>
              <th className="account-column">Account Name</th>
              {headers.map((header, index) => (
                <th key={index}>
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id={`tooltip-${index}`}>
                        {header.ToolTip}
                      </Tooltip>
                    }
                  >
                    <span style={{ cursor: "pointer" }}>
                      {header.Tool_Name}
                    </span>
                  </OverlayTrigger>
                </th>
              ))}
            </tr>
          </thead>

         <tbody>
  {currentItems.length > 0 ? (
    currentItems.map((row, rowIndex) => (
      <tr key={rowIndex}>
        <td className="account-column text-start">
          {row.Account_Name}
        </td>
        {headers.map((header, colIndex) => (
          <td
            key={colIndex}
            style={{
              backgroundColor:
                row[header.Tool_Name] || "#ffffff",
              height: "40px",
            }}
          />
        ))}
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan={headers.length + 1} className="text-center py-4">
        No Data Available
      </td>
    </tr>
  )}
</tbody>
        </Table>
      </div>

      <div className="d-flex justify-content-center">
        <Pagination>
          <Pagination.First
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          />
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />

          {[...Array(endPage - startPage + 1)].map((_, index) => {
            const pageNumber = startPage + index;
            return (
              <Pagination.Item
                key={pageNumber}
                active={pageNumber === currentPage}
                onClick={() => handlePageChange(pageNumber)}
              >
                {pageNumber}
              </Pagination.Item>
            );
          })}

          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
          <Pagination.Last
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>

    </div></div>
  );
};

export default Heatmap;